import { FC, HTMLProps } from 'react';

export const StrikeIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M17.5 9.375H11.2225C10.945 9.30038 10.6662 9.23058 10.3863 9.16562C8.63125 8.75062 7.63875 8.44687 7.63875 7.02625C7.6245 6.78101 7.66081 6.53546 7.74542 6.30484C7.83004 6.07422 7.96115 5.86345 8.13062 5.68562C8.6615 5.24906 9.32644 5.00851 10.0137 5.00437C11.7825 4.96062 12.5981 5.56063 13.265 6.47313L14.2744 5.73563C13.8019 5.0571 13.1578 4.51616 12.4078 4.16807C11.6578 3.81998 10.8288 3.67722 10.0056 3.75437C8.99439 3.76083 8.01887 4.12909 7.25563 4.7925C6.96634 5.08594 6.74024 5.43552 6.59125 5.8197C6.44227 6.20388 6.37356 6.6145 6.38937 7.02625C6.36197 7.4768 6.4466 7.92713 6.63572 8.33699C6.82483 8.74685 7.11254 9.10347 7.47312 9.375H2.5V10.625H11.0325C12.2619 10.9812 12.9969 11.445 13.0156 12.7237C13.0359 12.9969 12.9985 13.2713 12.9056 13.529C12.8128 13.7867 12.6667 14.0219 12.4769 14.2194C11.8155 14.7407 10.9938 15.0166 10.1519 15C9.52345 14.9818 8.90738 14.8209 8.35029 14.5295C7.7932 14.2382 7.30966 13.8239 6.93625 13.3181L5.97812 14.1206C6.46358 14.7676 7.08994 15.2955 7.80972 15.6645C8.52951 16.0334 9.32384 16.2336 10.1325 16.25H10.195C11.3492 16.2633 12.4695 15.8596 13.35 15.1131C13.6625 14.798 13.9054 14.4209 14.0632 14.0061C14.2209 13.5914 14.2898 13.1481 14.2656 12.705C14.289 11.947 14.0332 11.2069 13.5469 10.625H17.5V9.375Z"
        fill="currentColor"
      />
    </svg>
  );
};
